// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#mc_embed_signup[data-v-a81ff520]{background:#fff;clear:left;font:14px Helvetica,Arial,sans-serif}#mc-embedded-subscribe-form input[type=checkbox][data-v-a81ff520]{display:inline;width:auto;margin-right:10px}#mergeRow-gdpr[data-v-a81ff520]{margin-top:20px}#mergeRow-gdpr fieldset label[data-v-a81ff520]{font-weight:400}#mc-embedded-subscribe-form .mc_fieldset[data-v-a81ff520]{border:none;min-height:0;padding-bottom:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
